module.exports = __webpack_public_path__ + "static/media/shiyongzu.105e9a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/shiyongzu.png
// module id = 752
// module chunks = 0